import { userDetailsFromID } from "@/src/utils/userUtils.js";

export default {
  namespaced: true,

  state: {
    agentDetails: null,
    selectedConversation: null,
    pendingConversationId: null,
    sourceEntityId: null,
  },

  mutations: {
    SET_AGENT_DETAILS(state, value) {
      state.agentDetails = value;
    },

    SET_SELECTED_CONVERSATION(state, value) {
      state.selectedConversation = value;
    },

    SET_PENDING_CONVERSATION_ID(state, value) {
      state.pendingConversationId = value;
    },
    SET_SOURCE_ENTITY_ID(state, value) {
      state.sourceEntityId = value;
    },
  },
  actions: {
    setAgentDetails({ commit }, value) {
      commit("SET_AGENT_DETAILS", value);
    },

    async setSelectedConversation({ commit }, value) {
      commit("SET_SELECTED_CONVERSATION", value);

      if (value?.agent_id) {
        try {
          const agentDetails = await userDetailsFromID(value.agent_id);
          if (agentDetails) {
            commit("SET_AGENT_DETAILS", agentDetails);
          }
        } catch (error) {
          console.error("Error fetching agent details:", error);
        }
      } else {
        commit("SET_AGENT_DETAILS", null);
      }
    },

    setSourceEntityId({ commit }, value) {
      commit("SET_SOURCE_ENTITY_ID", value);
    },

    setEntityDetails({ commit, state }, value) {
      if (!state.selectedConversation) {
        console.warn("Cannot set entity details: no conversation selected");
        return;
      }

      commit("SET_SELECTED_CONVERSATION", {
        ...state.selectedConversation,
        entity_details: value,
      });
    },

    setEntityDetailsLoading({ commit, state }, value) {
      if (!state.selectedConversation) {
        console.warn(
          "Cannot set entity details loading: no conversation selected",
        );
        return;
      }

      commit("SET_SELECTED_CONVERSATION", {
        ...state.selectedConversation,
        entity_details_loading: value,
      });
    },

    setPendingConversationId({ commit }, value) {
      commit("SET_PENDING_CONVERSATION_ID", value);
    },

    clearPendingConversationId({ commit }) {
      commit("SET_PENDING_CONVERSATION_ID", null);
    },
  },

  getters: {
    selectedConversation: (state) => state.selectedConversation,
    selectedConversationID: (state) => state.selectedConversation?.id,
    entityDetails: (state) => state.selectedConversation?.entity_details,
    entityDetailsLoading: (state) =>
      state.selectedConversation?.entity_details_loading,
    agentDetails: (state) => state.agentDetails,
    pendingConversationId: (state) => state.pendingConversationId,
    sourceEntityId: (state) => state.sourceEntityId,
  },
  
}
